const WORDS = ['Bigger ideas', 'Bolder designs', 'Stronger brands', 'Creative Design', 'Content Editing', 'Branding', 'Websites', 'Motion', 'Identity'];

export function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="relative py-6 overflow-hidden border-y border-white/10" style={{ maskImage: 'linear-gradient(90deg, transparent, #000 12%, #000 88%, transparent)' }} data-testid="marquee" aria-hidden>
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center">
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="font-display text-sm sm:text-base tracking-[0.35em] uppercase text-white/55 px-8 flex items-center gap-8">
                {w} <span className="h-1.5 w-1.5 rounded-full bg-[#f97316] shadow-[0_0_12px_#f97316]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
